import React from "react";

function Logo(props) {
    return (
        <div className="w-full flex justify-center h-screen lg:h-96 overflow-hidden items-center -mt-24 sm:mt-0 ">
            <img
                alt="Peach logo"
                src="images/Logo.png"
                className="h-auto max-h-96 w-auto"
            />
        </div>
    );
}

export default Logo;
